export function replaceRecipeInPlan(prevPlan, oldRecipeName, newRecipe) {
  const updatedPlan = {};

  Object.keys(prevPlan).forEach((dateKey) => {
    updatedPlan[dateKey] = { ...prevPlan[dateKey] };

    ["breakfast", "lunch", "dinner"].forEach((mealType) => {
      const meal = prevPlan[dateKey]?.[mealType];
      if (meal?.name === oldRecipeName) {
        updatedPlan[dateKey][mealType] = newRecipe;
      }
    });
  });

  return updatedPlan;
}

export function removeRecipeFromPlan(prevPlan, recipeNameToRemove) {
  const updatedPlan = {};

  Object.keys(prevPlan).forEach((dateKey) => {
    updatedPlan[dateKey] = { ...prevPlan[dateKey] };

    ["breakfast", "lunch", "dinner"].forEach((mealType) => {
      const meal = prevPlan[dateKey]?.[mealType];
      if (meal?.name === recipeNameToRemove) {
        updatedPlan[dateKey][mealType] = null;
      }
    });
  });

  return updatedPlan;
}